import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Comparatif from "@/pages/Comparatif";
import Cotes from "@/pages/Cotes";
import Review from "@/pages/Review";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Competition from "@/pages/Competition";
import CoupeDuMonde from "@/pages/CoupeDuMonde";
import Actus from "@/pages/Actus";
import APropos from "@/pages/APropos";
import NousContacter from "@/pages/NousContacter";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import ArticleDetail from "@/pages/ArticleDetail";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Actus />} />
                        <Route
                            path="/actualites/categorie/:categorySlug"
                            element={<Actus />}
                        />
                        <Route path="/comparatif" element={<Comparatif />} />
                        <Route path="/cotes" element={<Cotes />} />
                        <Route path="/avis/:slug" element={<Review />} />
                        <Route path="/guides" element={<Guides />} />
                        <Route
                            path="/guides/:slug"
                            element={<GuideDetail />}
                        />
                        <Route
                            path="/articles/:slug"
                            element={<ArticleDetail />}
                        />
                        <Route
                            path="/coupe-du-monde-2026"
                            element={<CoupeDuMonde />}
                        />
                        <Route
                            path="/competitions/coupe-du-monde"
                            element={<Navigate to="/coupe-du-monde-2026" replace />}
                        />
                        <Route
                            path="/competitions/:slug"
                            element={<Competition />}
                        />
                        <Route path="/actus" element={<Navigate to="/" replace />} />
                        <Route path="/a-propos" element={<APropos />} />
                        <Route path="/nous-contacter" element={<NousContacter />} />
                        <Route
                            path="/about"
                            element={<Navigate to="/a-propos" replace />}
                        />
                        <Route path="/mentions-legales" element={<Legal />} />
                        <Route
                            path="/politique-editoriale"
                            element={<Legal />}
                        />
                        <Route
                            path="/politique-confidentialite"
                            element={<Legal />}
                        />
                        <Route
                            path="/politique-cookies"
                            element={<Legal />}
                        />
                        <Route path="/jeu-responsable" element={<Legal />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
